module.exports = __webpack_public_path__ + "static/html-element-advanced_2-10b97162f006bdd8f1b751d4bd41be0d.jpg";